export default {
	init: () => {

        const $searchForm = document.querySelector('.js-searchForm')
        if($searchForm){
            const $secteur = $searchForm.querySelector('[name="secteur"]')
            const $indication = $searchForm.querySelector('[name="indication"]')
            const $indication_options = $indication.querySelectorAll('option')
            const $ligne_de_traitement = $searchForm.querySelector('[name="ligne_de_traitement"]')
            const $ligne_de_traitement_options = $ligne_de_traitement.querySelectorAll('option')
            if ($secteur) {
                function filterIndications(){
                    let secteur_value = $secteur.value;
                    if($indication_options){
                        $indication_options.forEach($option => { // filtre les indications selon le secteur choisis
                            if(secteur_value != '' && secteur_value != $option.getAttribute('data-secteur-slug') && $option.value != ''){
                                $option.style.display = 'none';
                                $option.style.visibility = 'hidden';
                                $option.disabled = true;
                                $option.selected = false;
                            }else{
                                $option.style.display = 'block';
                                $option.disabled = false;
                                $option.style.visibility = 'visible';
                            }
                        });
                        if(secteur_value == ''){// réinitialiser l'indication et la ligne de traitement si on sélectionne "Secteur"
                            $indication_options.forEach($option => {
                                $option.selected = false;
                            });
                            $ligne_de_traitement_options.forEach($option => {
                                $option.selected = false;
                            });
                        }
                    }

                }
                $secteur.addEventListener('change', (e) => {
                    filterIndications();
                });
                filterIndications();
            }
        }

	}
}